import { render, staticRenderFns } from "./VDropzone.vue?vue&type=template&id=b6c69252&"
import script from "./VDropzone.vue?vue&type=script&lang=ts&"
export * from "./VDropzone.vue?vue&type=script&lang=ts&"
import style0 from "./VDropzone.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports